import React, { useEffect } from "react";
import StyleProperties from "../Shared/StyleProperties";
import Coordinates from "../Shared/Coordinates";
import Details from "../Shared/Details";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateShape } from "../../../../GlobalData/Shapes/actions";
import MapDisplayOptions from "../Shared/MapDisplayOptions";

const CircleEditor = () => {
	const properties = useSelector((state) => state.mapState.mapTools.feature?.properties);

	const dispatch = useDispatch();

	useEffect(() => {
		if (properties) {
			const { polyStroke, polyFill, polyFillOpacity, lineWidth, lineType, lineStrokeOpacity, otherFeatures } =
				properties;
			dispatch(
				createOrUpdateShape("circle", {
					otherFeatures,
					polyStroke,
					polyFill,
					polyFillOpacity: polyFillOpacity * 100,
					lineWidth,
					lineStrokeOpacity: lineStrokeOpacity * 100,
					lineType
				})
			);
		}
	}, []);

	return (
		<div>
			<Details shapeName="Shape name" shapeType="circle" />
			<MapDisplayOptions shapeType="circle" />
			<StyleProperties shapeType="circle" defaultStrokeColor="#96CC63" />
			<Coordinates />
		</div>
	);
};
export default CircleEditor;
